export default __webpack_public_path__ + "static/media/HV-UN-1T.75e89275.png";